import { combineReducers } from 'redux'
import filter from './filter'
import multiselect from './multiselect'

export default combineReducers({
  filter,
  multiselect,
})
